// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceUsageContent, unionToDeviceUsageContent, unionListToDeviceUsageContent } from './device-usage-content';
import { ElevatorUsageMessage, ElevatorUsageMessageT } from './elevator-usage-message';
import { EscalatorUsageMessage, EscalatorUsageMessageT } from './escalator-usage-message';


export class UsageMessage implements flatbuffers.IUnpackableObject<UsageMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):UsageMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsUsageMessage(bb:flatbuffers.ByteBuffer, obj?:UsageMessage):UsageMessage {
  return (obj || new UsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsUsageMessage(bb:flatbuffers.ByteBuffer, obj?:UsageMessage):UsageMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new UsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():DeviceUsageContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceUsageContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startUsageMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:DeviceUsageContent) {
  builder.addFieldInt8(0, messageType, DeviceUsageContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endUsageMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createUsageMessage(builder:flatbuffers.Builder, messageType:DeviceUsageContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  UsageMessage.startUsageMessage(builder);
  UsageMessage.addMessageType(builder, messageType);
  UsageMessage.addMessage(builder, messageOffset);
  return UsageMessage.endUsageMessage(builder);
}

unpack(): UsageMessageT {
  return new UsageMessageT(
    this.messageType(),
    (() => {
      const temp = unionToDeviceUsageContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: UsageMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToDeviceUsageContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class UsageMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: DeviceUsageContent = DeviceUsageContent.NONE,
  public message: ElevatorUsageMessageT|EscalatorUsageMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return UsageMessage.createUsageMessage(builder,
    this.messageType,
    message
  );
}
}
